import {
  CalendarEventIcon,
  Multiple11Icon,
  PrivacyPolicyIcon,
  TrophyIcon,
} from 'fitify-ui/src/Icon/fill'
import type { DataTypes } from 'fitify-ui-landing/src/@types'

export const businessHowItWorksData: DataTypes.HowItWorksItem[] = [
  {
    icon: <PrivacyPolicyIcon />,
    iconColor: 'Blue400',
    title: 'landing_work_how_it_works_block_1_title',
    content: 'landing_work_how_it_works_block_1_subtitle',
  },
  {
    icon: <CalendarEventIcon />,
    iconColor: 'Blue400',
    title: 'landing_work_how_it_works_block_2_title',
    content: 'landing_work_how_it_works_block_2_subtitle',
  },
  {
    icon: <Multiple11Icon />,
    iconColor: 'Blue400',
    title: 'landing_work_how_it_works_block_3_title',
    content: 'landing_work_how_it_works_block_3_subtitle',
  },
  {
    icon: <TrophyIcon />,
    iconColor: 'Blue400',
    title: 'landing_work_how_it_works_block_4_title',
    content: 'landing_work_how_it_works_block_4_subtitle',
  },
]
